<mat-vertical-stepper [linear]="false" #stepper>
    <mat-step [stepControl]="mform">
        <ng-template matStepLabel> Machine Form</ng-template>
        <!-- machine-form.component.html -->

        <form [formGroup]="mform" class="p-4 space-y-6">
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">

                <!-- Start Date -->
                <mat-form-field appearance="fill">
                    <mat-label>Start Date</mat-label>
                    <input matInput type="date" formControlName="startDate">
                    <mat-error *ngIf="mform.get('startDate')?.hasError('required')">Start date is required</mat-error>
                </mat-form-field>

                <!-- End Date -->
                <mat-form-field appearance="fill">
                    <mat-label>End Date</mat-label>
                    <input matInput type="date" formControlName="endDate">
                    <mat-error *ngIf="mform.get('endDate')?.hasError('required')">End date is required</mat-error>
                </mat-form-field>

                <!-- Machine Type -->
                <mat-form-field appearance="fill">
                    <mat-label>Machine Type</mat-label>
                    <input matInput formControlName="machineType">
                    <mat-error *ngIf="mform.get('machineType')?.hasError('required')">Machine type is
                        required</mat-error>
                </mat-form-field>

                <!-- Machine Name -->
                <mat-form-field appearance="fill">
                    <mat-label>Machine Name</mat-label>
                    <input matInput formControlName="machineName">
                    <mat-error *ngIf="mform.get('machineName')?.hasError('required')">Machine name is
                        required</mat-error>
                </mat-form-field>

                <!-- Machine Brand -->
                <mat-form-field appearance="fill">
                    <mat-label>Machine Brand</mat-label>
                    <input matInput formControlName="machineBrand">
                    <mat-error *ngIf="mform.get('machineBrand')?.hasError('required')">Brand is required</mat-error>
                </mat-form-field>

                <!-- Machine Model -->
                <mat-form-field appearance="fill">
                    <mat-label>Machine Model</mat-label>
                    <input matInput formControlName="machineModel">
                    <mat-error *ngIf="mform.get('machineModel')?.hasError('required')">Model is required</mat-error>
                </mat-form-field>

                <!-- Serial Number -->
                <mat-form-field appearance="fill">
                    <mat-label>Serial Number</mat-label>
                    <input matInput formControlName="serialNumber">
                    <mat-error *ngIf="mform.get('serialNumber')?.hasError('required')">Serial number is
                        required</mat-error>
                </mat-form-field>

                <!-- Select Project -->
                <mat-form-field appearance="fill">
                    <mat-label>Select Project</mat-label>
                    <mat-select formControlName="selectProject">
                        <mat-option value="">Select</mat-option>
                        <mat-option value="project1">Project 1</mat-option>
                        <mat-option value="project2">Project 2</mat-option>
                    </mat-select>
                    <mat-error *ngIf="mform.get('selectProject')?.hasError('required')">Project is required</mat-error>
                </mat-form-field>

                <!-- Status -->
                <mat-form-field appearance="fill">
                    <mat-label>Status</mat-label>
                    <mat-select formControlName="status">
                        <mat-option value="">Select</mat-option>
                        <mat-option value="Active">Active</mat-option>
                        <mat-option value="Inactive">Inactive</mat-option>
                    </mat-select>
                    <mat-error *ngIf="mform.get('status')?.hasError('required')">Status is required</mat-error>
                </mat-form-field>

                <!-- Purchase Date -->
                <mat-form-field appearance="fill">
                    <mat-label>Purchase Date</mat-label>
                    <input matInput type="date" formControlName="purchaseDate">
                    <mat-error *ngIf="mform.get('purchaseDate')?.hasError('required')">Purchase date is
                        required</mat-error>
                </mat-form-field>
            </div>

            <div class="text-right">
                <button mat-raised-button color="primary" matStepperNext [disabled]="!mform.valid">
                    {{ "NEXT" | translate }}
                </button>
            </div>

        </form>

    </mat-step>
     <mat-step [stepControl]="mform">
        <ng-template matStepLabel> Equipment Tools</ng-template>
        <!-- equipment-tools.component.html -->

<form [formGroup]="equipmentToolsForm"  class="space-y-6 p-6">

  <!-- Heavy Equipment Section -->
  <fieldset formGroupName="heavyEquipment" class="p-4 border rounded-md shadow-md">
    <legend class="text-lg font-semibold">Heavy Equipment</legend>

    <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
      <mat-form-field appearance="fill">
        <mat-label>Type</mat-label>
        <input matInput formControlName="type">
        <mat-error *ngIf="equipmentToolsForm.get('heavyEquipment.type')?.hasError('required')">Type is required</mat-error>
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Make/Model</mat-label>
        <input matInput formControlName="makeModel">
        <mat-error *ngIf="equipmentToolsForm.get('heavyEquipment.makeModel')?.hasError('required')">Make/Model is required</mat-error>
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Capacity</mat-label>
        <input matInput formControlName="capacity">
        <mat-error *ngIf="equipmentToolsForm.get('heavyEquipment.capacity')?.hasError('required')">Capacity is required</mat-error>
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Ownership</mat-label>
        <input matInput formControlName="ownership">
        <mat-error *ngIf="equipmentToolsForm.get('heavyEquipment.ownership')?.hasError('required')">Ownership is required</mat-error>
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Maintenance Schedule</mat-label>
        <input matInput formControlName="maintenanceSchedule">
        <mat-error *ngIf="equipmentToolsForm.get('heavyEquipment.maintenanceSchedule')?.hasError('required')">Schedule is required</mat-error>
      </mat-form-field>
    </div>
  </fieldset>

  <!-- Testing Equipment Section -->
  <fieldset formGroupName="testingEquipment" class="p-4 border rounded-md shadow-md">
    <legend class="text-lg font-semibold">Testing Equipment</legend>

    <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
      <mat-form-field appearance="fill">
        <mat-label>Type</mat-label>
        <input matInput formControlName="type">
        <mat-error *ngIf="equipmentToolsForm.get('testingEquipment.type')?.hasError('required')">Type is required</mat-error>
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Calibration Status</mat-label>
        <input matInput formControlName="calibrationStatus">
        <mat-error *ngIf="equipmentToolsForm.get('testingEquipment.calibrationStatus')?.hasError('required')">Calibration status is required</mat-error>
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Lab Certification</mat-label>
        <input matInput formControlName="labCertification">
        <mat-error *ngIf="equipmentToolsForm.get('testingEquipment.labCertification')?.hasError('required')">Certification is required</mat-error>
      </mat-form-field>
    </div>
  </fieldset>

  <!-- Tools Inventory Section -->
  <fieldset formGroupName="toolsInventory" class="p-4 border rounded-md shadow-md">
    <legend class="text-lg font-semibold">Tools Inventory</legend>

    <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
      <mat-form-field appearance="fill">
        <mat-label>Type & Quantity</mat-label>
        <input matInput formControlName="typeQuantity">
        <mat-error *ngIf="equipmentToolsForm.get('toolsInventory.typeQuantity')?.hasError('required')">Required</mat-error>
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Condition</mat-label>
        <input matInput formControlName="condition">
        <mat-error *ngIf="equipmentToolsForm.get('toolsInventory.condition')?.hasError('required')">Condition is required</mat-error>
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Replacement Schedule</mat-label>
        <input matInput formControlName="replacementSchedule">
        <mat-error *ngIf="equipmentToolsForm.get('toolsInventory.replacementSchedule')?.hasError('required')">Required</mat-error>
      </mat-form-field>
    </div>
  </fieldset>

  <!-- Submit -->
  <div class="text-right pt-4">
    <button mat-raised-button color="primary" type="submit">Submit</button>
  </div>
</form>

    </mat-step>

</mat-vertical-stepper>